export default "/assets/images/the-rookie-parent.12e0cbd0458b20f0.png";